import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';
import { Dropdown } from 'react-bootstrap';
import { useDispatch,useSelector } from 'react-redux';
import { getRoleListing } from '../../src/store/slices/RoleUser';
import { MANAGER_LEVEL_IDS } from '../../src/config/constant';
import secureStorage from "@src/config/encrypt";
import { FollowUpDate ,CreatedDate} from './DatePicker';
import MultiSelect from '../../src/common/MultiSelect';
import { getAgencyList } from '../../src/store/slices/common';
import {filters} from '../config/switch';
import { renderFilterField } from '../component/filter/FilterRenderer';
import { useLanguage } from '../../src/context/LanguageContext';
import { COUNTRY_CODE, APP_COUNTRY } from '../config/constant';

const { ValueContainer, Placeholder } = components;

const CustomValueContainer = (props: any) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(props.children, (child: any) =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};

type OptionType = {
  value: string;
  label: string;
};


const MoreFilter = (props: any) => {
  const { submitHandler, selectedFilters, setSelectedFilters, config, partnerList,assignUsers,paymentMethod } = props;  
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [userList, setUserList] = useState<any>([]);
  const dispatch: any = useDispatch();
  const [errors, setError] = useState<any>({});
  const [agencyList, setAgencyList] = useState<any>([]);
  const configDetail = useSelector((state: any) => state.common);
  const {translations} = useLanguage();
  useEffect(() => {
    const getUserList = async () => {
        dispatch(getRoleListing.getUserListData({})).then((res: any) => {
            if (res && res.status === 200) {
                setUserList(res.data);
            }
        }).catch((err: any) => {
        })
    };
    getUserList();
    // eslint-disable-next-line
  }, []);

  const getAgencyFilterData = () => {
    dispatch(getAgencyList()).then((res: any) => {
      if (res && res.status === 200) {        
        if (res.data) {
          setAgencyList(res.data);
        }
      }
    }).catch((err: Error) => {
    })
  }

  useEffect(() => {
    if(COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH){
      if (Object.keys(configDetail.agencyList).length === 0) {
        getAgencyFilterData();
      }else{
        setAgencyList(configDetail.agencyList);
      }
    }
    // eslint-disable-next-line
  },[])


  /**
    * FILTER SEARCH HANDLER
    */
  const onFilterSearch = () => {    
    submitHandler({ page_number: 1, ...selectedFilters });
    setPopupOpen(false);
  }

  /**
    * HANDLE CHANGE FOR SELECTED OPTIONS
  */
  const handleChange = (selectedOption: any, key: string) => {
    let updatedFilters: any = {};

    if (key === 'created_on' || key === 'followup_date') {
      // Handle date fields as multiselect (range or single)
      setError({})
      if(key === 'created_on' && selectedOption[0]?.format("YYYY-MM-DD")  === selectedOption[1]?.format("YYYY-MM-DD")){
        errors['created_on'] = 'Same start and end date'
        setError({...errors});
        return;
      }
      if (selectedOption.length === 2) {
        updatedFilters[`${key}_from`] = selectedOption[0] ? selectedOption[0].format("YYYY-MM-DD") : null;
        updatedFilters[`${key}_to`] = selectedOption[1] ? selectedOption[1].format("YYYY-MM-DD") : null;
      } else {
        updatedFilters[`${key}_from`] = selectedOption[0]?.format("YYYY-MM-DD");
        updatedFilters[`${key}_to`] = null;
      }
    } else if (selectedOption instanceof Array) {
      // For multi-select (array of options)
      updatedFilters[key] = selectedOption.map((e) => e.value);
      if(key === 'agency_id'){
        updatedFilters['agency_names'] = selectedOption;
      }
    } else {
      // For single select
      updatedFilters[key] = selectedOption?.value || null;
    }

    setSelectedFilters((prev: any) => ({
      ...prev, // keep old filters
      ...updatedFilters, // merge new filters
    }));
  };

  /**
     * FILTER RESET HANDLER
     */
    const onFilterReset = () => {
      setSelectedFilters({});
      submitHandler({});
      setPopupOpen(false);
  }

   const transformedUserList = userList.map((user: any) => ({
            value: user.id,
            label: user.name
      }));

    const authUserInfo = secureStorage.getItem("authUserInfo");    

  return (
    <div className="filter-option">
      <Dropdown show={isPopupOpen} onToggle={(isOpen: any) => setPopupOpen(isOpen)}>
        <div className="text-btn d-flex">
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            <span className="more-filter-txt">More Filters</span>
            <span className="leass-filter-txt">Less Filters</span>
          </Dropdown.Toggle>

          <div className="btn-submit-reset top-btn-none">
            <button className="btn-primary" onClick={onFilterSearch}>Search</button>
            <button className="btn-reset" onClick={onFilterReset}>Reset</button>
          </div>
        </div>

        <Dropdown.Menu>
          <div className="more-filter-option">
            <h3>More Filters</h3>
            <div className="filter-form">
              {filters.leadListMoreFilters(translations).map((filter:any) =>
                  renderFilterField(filter, { selectedFilters, handleChange, translations, authUserInfo, CustomValueContainer,
                      options: { 
                          lead_types: config?.lead_types,
                          transformedUserList: transformedUserList,
                          insurance_type: config?.insurance_type,
                          lead_status: config?.lead_status,
                          partnerList:partnerList,
                          agencyList:agencyList,
                          assigning_filters:config?.assigning_filters,
                          payment_status:config?.payment_status,
                          payment_method:paymentMethod,
                          assign_user_id:assignUsers
                      }
                  })
              )}
              {/* <fieldset className="p-lg-b dateShowField">
                <div className="material">
                  <CreatedDate selectedFilters={selectedFilters} handleChange={handleChange} />
                   <span className="error-txt">
                        {errors.created_on || ""}
                    </span>
                </div>
              </fieldset>

              <fieldset className="p-lg-b">
                <div className="material">
                  <FollowUpDate selectedFilters={selectedFilters} handleChange={handleChange} />
                </div>
              </fieldset>
              {MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids) && (
                <fieldset className="single-select">
                  <div  className="material">
                    <MultiSelect
                      isSelectAll={true}
                      options={config['lead_types']}
                      placeholder="Source Type"
                      value={
                        (config['lead_types'] instanceof Array &&
                          selectedFilters?.source &&
                          config['lead_types'].filter((e: any) =>
                            [...(selectedFilters?.source instanceof Array ? selectedFilters?.source : [])].includes(e.value)
                          )) || []
                      }
                      onChange={(e: any) => handleChange(e, 'source')}
                      className="react-select"
                      classNamePrefix="react-select"
                    />
                  </div>

                </fieldset>
                )}

                <fieldset className="single-select">
                  <div className="material">
                    <Select<OptionType>
                      value={transformedUserList.find((option: any) => option.value === selectedFilters.created_by) || null}
                      components={{ ValueContainer: CustomValueContainer }}
                      options={transformedUserList}
                      placeholder="Created By"
                      className="react-select"
                      classNamePrefix="react-select"
                      isClearable
                      onChange={(e: any) => handleChange(e, 'created_by')}
                    />
                  </div>
                </fieldset>

                <fieldset className="single-select">
                  <div className="material">
                    <Select<OptionType>
                      value={config["insurance_type"]?.find((option: any) => option.value === selectedFilters.insurance_type) || null}
                      components={{ ValueContainer: CustomValueContainer }}
                      options={config["insurance_type"]}
                      placeholder="Insurance Type"
                      className="react-select"
                      classNamePrefix="react-select"
                      isClearable
                      onChange={(e: any) => handleChange(e, 'insurance_type')}
                    />
                  </div>
                </fieldset>

                <fieldset className="single-select">
                  <div className="material">
                    <Select<OptionType>
                      value={config["lead_status"]?.find((option: any) => option.value === selectedFilters.status) || null}
                      components={{ ValueContainer: CustomValueContainer }}
                      options={config["lead_status"]}
                      placeholder="Status"
                      className="react-select"
                      classNamePrefix="react-select"
                      isClearable
                      onChange={(e: any) => handleChange(e, 'status')}
                    />
                  </div>
                </fieldset>

              <fieldset className="single-select">
                <div className="material">
                  <Select<OptionType>
                    components={{ ValueContainer: CustomValueContainer }}
                    options={partnerList}
                    placeholder="Insurer Name"
                    className="react-select"
                    classNamePrefix="react-select"
                    isClearable
                    onChange={(e: any) => handleChange(e, 'insured_name')}
                    value={partnerList?.find((option: any) => option.value === selectedFilters.insured_name) || null}
                  />
                </div>
              </fieldset>

              <fieldset className="single-select">
                  <div  className="material">
                    <MultiSelect
                      isSelectAll={true}
                      options={agencyList}
                      placeholder="Agency Name"
                      value={
                        (agencyList instanceof Array &&
                          selectedFilters?.agency_id &&
                          agencyList.filter((e: any) =>
                            [...(selectedFilters?.agency_id instanceof Array ? selectedFilters?.agency_id : [])].includes(e.value)
                          )) || []
                      }
                      onChange={(e: any) => handleChange(e, 'agency_id')}
                      className="react-select"
                      classNamePrefix="react-select"
                    />
                  </div>

                </fieldset>

                {MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids) && (
                  <fieldset className="single-select">
                    <div className="material">
                      <Select<OptionType>
                        components={{ ValueContainer: CustomValueContainer }}
                        options={config?.assigning_filters}
                        placeholder="Assignment Status"
                        className="react-select"
                        classNamePrefix="react-select"
                        isClearable
                        onChange={(e: any) => handleChange(e, 'assignment_status')}
                        value={config?.assigning_filters?.find((option: any) => option.value === selectedFilters.assignment_status) || null}
                      />
                    </div>
                  </fieldset>
                  )
                } */}


                <div className="btn-submit-reset more-filter-btn">
                  <button className="btn-primary" onClick={onFilterSearch}>Search</button>
                  <button className="btn-reset" onClick={onFilterReset}>Reset</button>
                </div>
            </div>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default MoreFilter;
